/* JustPure motion runtime.
 *
 * Applies the reveal treatment across every page without editing 39 section
 * files: it walks the rendered shopify-section wrappers and tags one group per
 * section.
 *
 * Two rules earned the hard way:
 *   - never tag an element that already sits inside a tagged one, or the child
 *     inherits opacity:0 from a parent that has not fired yet;
 *   - never leave anything hidden. A failsafe reveals whatever is still
 *     untouched shortly after load, so a missed observer can never cost the
 *     visitor content.
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SKIP = /header|footer|announcement|jp-sticky|jp-wa|jp-offer|marquee|slider|swiper|carousel|photoswipe/i;

  function pick(sec) {
    // One group per section: the widest content wrapper that is not the section
    // itself, so the fade covers a coherent block.
    var out = [];
    var grids = sec.querySelectorAll(
      '.jp-products-grid, .jp-bundles__grid, [class*="__grid"], [class*="-grid"], [class*="-cards"]'
    );
    for (var i = 0; i < grids.length && out.length < 2; i++) out.push(grids[i]);

    var head = sec.querySelector('[class*="__head"], [class*="-header"]');
    if (head) out.push(head);

    if (!out.length) {
      var first = sec.firstElementChild;
      if (first) out.push(first);
    }
    return out;
  }

  function run() {
    var sections = document.querySelectorAll('[id^="shopify-section"], .shopify-section');
    var picked = [];

    for (var s = 0; s < sections.length; s++) {
      var sec = sections[s];
      if (SKIP.test(sec.id || '') || SKIP.test(sec.className || '')) continue;
      var group = pick(sec);
      for (var g = 0; g < group.length; g++) picked.push(group[g]);
    }

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        entries[i].target.classList.add('jp-in');
        io.unobserve(entries[i].target);
      }
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });

    var vh = window.innerHeight || 800;

    for (var p = 0; p < picked.length; p++) {
      var el = picked[p];
      if (el.classList.contains('jp-reveal')) continue;

      // A nested target would inherit its ancestor's opacity:0 and could stay
      // invisible if the ancestor never enters view.
      if (el.closest('.jp-reveal')) continue;

      el.classList.add('jp-reveal');

      if (el.getBoundingClientRect().top < vh * 0.95) {
        el.classList.add('jp-in');
        continue;
      }
      io.observe(el);
    }

    // Watchdog: if an element is scrolled past but its observer never fired,
    // reveal it. Checked on scroll rather than on a timer, so content below the
    // fold still animates in normally.
    window.addEventListener('scroll', function () {
      var left = document.querySelectorAll('.jp-reveal:not(.jp-in)');
      for (var i = 0; i < left.length; i++) {
        if (left[i].getBoundingClientRect().top < window.innerHeight) {
          left[i].classList.add('jp-in');
        }
      }
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);

  // Last-resort guard: if scripting stalls after this point, reveal everything
  // rather than leaving a page with invisible blocks.
  window.addEventListener('load', function () {
    setTimeout(function () {
      var left = document.querySelectorAll('.jp-reveal:not(.jp-in)');
      for (var i = 0; i < left.length; i++) left[i].classList.add('jp-in');
    }, 8000);
  });
})();
